export const EditPenIcon = ({ color = "#8D8D8D", size = 20, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M0 8.90781V11.2516H2.34375L9.25625 4.33906L6.9125 1.99531L0 8.90781ZM11.0687 2.52656C11.3125 2.28281 11.3125 1.88906 11.0687 1.64531L9.60625 0.182812C9.3625 -0.0609375 8.96875 -0.0609375 8.725 0.182812L7.58125 1.32656L9.925 3.67031L11.0687 2.52656Z" fill={color} />
    </svg>
);
